export function StaticsFinal(target: any): void {
	Object.freeze(target);
}

@StaticsFinal
export class ReportConstants {
    static readonly DateViewLabel = 'Date';
    static readonly DayOfWeekViewLabel = 'Day of Week';
    static readonly PeriodEndViewLabel = 'Period End';
    static readonly ShiftBlockViewLabel = 'Shift Block';
    static readonly WeekViewLabel = 'Week';
    static readonly CensusType = 'averageCensus';
    static readonly CostCenterLabel = 'Cost Center';
    static readonly JobTitleLabel = 'Job Title';
}
